import { RefObject, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createThread } from 'src/presentation/components/pages/sidekick/threads/actions/threadActions';
import { NewThreadModalRef } from 'src/presentation/components/pages/sidekick/threads/components/NewThreadModal';
import {
  selectLastCreatedThreadId,
  setLastCreatedThreadId,
  setShowLoadingIndicator,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

const useCreateNewThread = ({
  newThreadModalRef,
  onNewThreadCreated,
}: {
  newThreadModalRef: RefObject<NewThreadModalRef>;
  onNewThreadCreated: (threadId: number) => void;
}) => {
  const dispatch = useDispatch();
  const lastCreatedThreadId = useSelector(selectLastCreatedThreadId);

  const ref = useRef<any>({ handleNewThreadCreated: null });

  useEffect(() => {
    if (lastCreatedThreadId) {
      if (!ref.current?.handleNewThreadCreated) {
        return;
      }
      ref.current.handleNewThreadCreated(lastCreatedThreadId);
    }
  }, [lastCreatedThreadId, ref]);

  const subscribeCreateNew = (params: unknown) => {
    dispatch(setShowLoadingIndicator(true));

    ref.current.handleNewThreadCreated = (lastCreatedThreadId: number) => {
      setTimeout(() => {
        onNewThreadCreated(lastCreatedThreadId);
        dispatch(setShowLoadingIndicator(false));
      });

      ref.current.handleNewThreadCreated = null;
      dispatch(setLastCreatedThreadId(null));
    };

    const name = params as string;

    setTimeout(() => {
      dispatch(createThread({ threadName: name }));
    });
  };

  const show = () => {
    if (!newThreadModalRef || !newThreadModalRef.current) {
      return;
    }

    newThreadModalRef.current.show({
      title: 'Create Thread',
      confirmButtonLabel: 'Create',
      subscribe: subscribeCreateNew,
      thread: null,
    });
  };

  return { show };
};

export default useCreateNewThread;
